import React from 'react'

export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`font-bold ${className}`}>
      kon<span className="text-primary">reji</span>
    </span>
  )
}
